module.exports = __webpack_public_path__ + "static/img/title.f3d47a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/feature6/title.png
// module id = 6ssp
// module chunks = 7